import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Table, Container, Col, Row, Image } from "react-bootstrap";
import "./style.css";
import moment from "moment";
// import { useLoader } from "../../../context/LoaderContext";
import DateRangePicker from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { fetchCreditLogBooks } from "../../../store/eventsSlice";
import {
  MoneyAdd02Icon,
  MoneyRemove02Icon,
  MoneyReceiveFlow02Icon,
  Layers01Icon,
  Cancel01Icon,
} from "../../../icons/icons";
import CreatableSelect from "react-select/creatable";
import TableLoader from "../../../components/TableLoader";
import CommomButton from "../../../components/common-button";
import SmallCreditWidgets from "../../../components/winget/credit-small-wingets";
// import SelectBox from "../../../components/select-box";
import Input from "../../../components/input";
import Credit from "../recharge-history/Credit";
import { recordsPerPageOptions } from "../campaings/common/Common";
import CommonPagination from "../../../components/common-pagination";
import CreditHistorySelect from "../../../components/credit-history-select/CreditHistorySelect";

const List2 = () => {
  // const { setLoading } = useLoader();
  const dispatch = useDispatch();
  // const [showSnackbar, setShowSnackbar] = useState(false);
  // const [snackbarMessage, setSnackbarMessage] = useState("");
  // const [snackbarVariant, setSnackbarVariant] = useState("toast-success");
  const [currentPage, setCurrentPage] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [creditFilter, setCreditFilter] = useState(null);
  // const creditLoader = useSelector((state) => state?.events?.loader);

  

  const [limit, setLimit] = useState({ value: 10, label: 10 });

  const [creditHistoryList, setCreditHistoryList] = useState([]);
  const [total, setTotal] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);

  // console.log("creditHistoryList", creditHistoryList);

  // const toastMessage = localStorage.getItem("toastMessage");

  const [dateRange, setDateRange] = useState({
    startDate: moment().subtract(29, "days"),
    endDate: moment(),
  });

  const [searchTerm, setSearchTerm] = useState("");

  const dropdownOptions = [
    { value: "", label: "Select Credits" },
    { value: "all", label: "All Credits" },
    { value: "all_debits", label: "All Debits Credits" },
    { value: "all_credits", label: "All Credit Credits" },
  ];

  const getCreditsLog = useCallback(() => {
    setTableLoading(true);
    dispatch(
      fetchCreditLogBooks({
        start_date: dateRange?.startDate.format("YYYY/MM/DD"),
        end_date: dateRange?.endDate.format("YYYY/MM/DD"),
        offset: currentPage,
        limit: limit?.value,
        log_filter: creditFilter?.value,
        search: searchTerm,
      })
    )
      .then((res) => {
          setCreditHistoryList(res?.payload?.data);
          setTotal(res?.payload?.total);
      })
      .catch(() => {
        setTableLoading(false);
      })
      .finally(() => {
        setTableLoading(false);
      });
  }, [
    dispatch,
    dateRange?.startDate,
    dateRange?.endDate,
    currentPage,
    limit?.value,
    creditFilter?.value,
    searchTerm,
    setTableLoading,
  ]);


  useEffect(() => {
    getCreditsLog();
  }, [getCreditsLog]);

  const handleChange = (newValue) => {
    if (newValue) {
      // Update state with both value and label
      setLimit({ value: newValue.value, label: newValue.label });
      setCurrentPage(0);
    } else {
      // If the value is null (when user clears selection), set a default value
      setLimit({ value: 10, label: 10 }); // Set to default object
      setCurrentPage(0);
    }
  };

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber - 1);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick(e);
      }}
      className="text-muted text-primary-hover"
      role="button"
    >
      {children}
    </div>
  ));

  CustomToggle.displayName = "CustomToggle";

  const [selectedRangeLabel, setSelectedRangeLabel] = useState("This Year");

  const handleEvent = (event, picker) => {
    setCurrentPage(0);
    setDateRange({
      startDate: picker.startDate,
      endDate: picker.endDate,
    });

    // Added
    // Match the selected dates to a label in ranges
    const ranges = {
      Today: [moment(), moment()],
      Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
      "Last 7 Days": [moment().subtract(6, "days"), moment()],
      "Last 30 Days": [moment().subtract(29, "days"), moment()],
      "This Month": [moment().startOf("month"), moment().endOf("month")],
      "Last Month": [
        moment().subtract(1, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
      "Last 3 Months": [
        moment().subtract(3, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
      "Last 6 Months": [
        moment().subtract(6, "month").startOf("month"),
        moment().subtract(1, "month").endOf("month"),
      ],
      "This Year": [moment().startOf("year"), moment().endOf("year")],
    };

    const found = Object.entries(ranges).find(
      ([, range]) =>
        range[0].isSame(picker.startDate, "day") &&
        range[1].isSame(picker.endDate, "day")
    );

    setSelectedRangeLabel(found?.[0] || "Custom Range");
  };

  // const handleDropdownClick = (e) => {
  // Prevent dropdown from closing when clicking inside
  //   e.stopPropagation();
  // };

  const handleShow = () => setShowModal(true);
  const handleClose = () => {
    setShowModal(false);
    // getWalletList();
  };

  useEffect(() => {
  const ranges = {
    Today: [moment(), moment()],
    Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
    "Last 7 Days": [moment().subtract(6, "days"), moment()],
    "Last 30 Days": [moment().subtract(29, "days"), moment()],
    "This Month": [moment().startOf("month"), moment().endOf("month")],
    "Last Month": [
      moment().subtract(1, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "Last 3 Months": [
      moment().subtract(3, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "Last 6 Months": [
      moment().subtract(6, "month").startOf("month"),
      moment().subtract(1, "month").endOf("month"),
    ],
    "This Year": [moment().startOf("year"), moment().endOf("year")],
  };

  const found = Object.entries(ranges).find(
    ([, range]) =>
      range[0].isSame(dateRange.startDate, "day") &&
      range[1].isSame(dateRange.endDate, "day")
  );

  setSelectedRangeLabel(found?.[0] || "Custom Range");

  // OPTIONAL HACK: visually highlight correct range by simulating a click
  setTimeout(() => {
    const labelToHighlight = found?.[0] || "Custom Range";
    const rangeElements = document.querySelectorAll('.ranges li');
    rangeElements.forEach((li) => {
      if (li.textContent.trim() === labelToHighlight) {
        li.classList.add("active");
      } else {
        li.classList.remove("active");
      }
    });
  }, 100); // delay to wait for DOM to render
}, [dateRange.startDate, dateRange.endDate]);


  return (
    <>
      <Container fluid className="px-0 credit-history">
        <Row className="px-0 organization-list-content common-tab-spacing g-3">
          <Col xs={12} sm={12} md={12} lg={6} className="organization-widget">
            <div
              className="basic-wingets position-relative bg-white common-shadow h-100 rounded-2 my-credit-winget"
              style={{
                backgroundImage: `url('/images/credit-background.png')`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
              }}
            >
              <div className="text-content">
                <p className="fw-medium text-capitalize">My Credits</p>
                <h5 className="fw-medium mt-3">
                  {creditHistoryList?.opening_balance +
                    creditHistoryList?.total_credits -
                    creditHistoryList?.total_debits}{" "}
                  Credits
                </h5>
                <CommomButton
                  // onClick={handleAddClick}
                  onClick={() => handleShow()}
                  title="Request For Credit"
                  className="btn-primary common-one-shadow mt-4"
                />
              </div>

              <div className="image-content d-md-flex d-xl-flex'">
                <Image
                  src="/images/table-icon/credit-icon.svg"
                  alt="banner-image"
                  className=""
                />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6} className="organization-widget">
            <Row className="credit-small-winget-cover g-2 g-md-3">
              <Col xs={12} sm={6} xxl={4}>
                <SmallCreditWidgets
                  count={creditHistoryList?.opening_balance || 0}
                  title="Opening Balance"
                  icon={
                    <Layers01Icon
                      width={24}
                      height={24}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  //   onClick={() => handleStatusClick("pending")}
                  //   className={activeTabStatus === "pending" && "active"}
                />
              </Col>
              <Col xs={12} sm={6} xxl={4}>
                <SmallCreditWidgets
                  count={creditHistoryList?.total_credits || 0}
                  title="Purchased Credit"
                  icon={
                    <MoneyAdd02Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  //   onClick={() => handleStatusClick("pending")}
                  //   className={activeTabStatus === "pending" && "active"}
                />
              </Col>
              <Col xs={12} sm={6} xxl={4}>
                <SmallCreditWidgets
                  count={creditHistoryList?.total_debits || 0}
                  title="Used Credits"
                  icon={
                    <MoneyRemove02Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  //   onClick={() => handleStatusClick("pending")}
                  //   className={activeTabStatus === "pending" && "active"}
                />
              </Col>
              <Col xs={12} sm={6} xxl={4}>
                <SmallCreditWidgets
                  count={creditHistoryList?.closing_balance || 0}
                  title="Available Credits"
                  icon={
                    <MoneyReceiveFlow02Icon
                      width={26}
                      height={26}
                      color="#444050"
                      strokeWidth="1.5"
                    />
                  }
                  //   onClick={() => handleStatusClick("pending")}
                  //   className={activeTabStatus === "pending" && "active"}
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <div className="bg-white rounded-2 overflow-hidden common-shadow">
          <div className="comman-table-action-head d-flex align-items-center justify-content-between gap-4">
            <div className="position-relative">
              <Input
                type="search"
                value={searchTerm}
                placeholder="Search"
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setCurrentPage(0);
                }}
                className="shadow-none base-search"
              />

              {searchTerm && (
                <div>
                  <Cancel01Icon
                    height={14}
                    width={14}
                    color="#A5596A"
                    strokeWidth="3"
                    onClick={() => {
                      setSearchTerm("");
                    }}
                    className="cursor-pointer position-absolute top-50 translate-middle-y end-0 me-2"
                  />
                </div>
              )}
            </div>

            <div className="d-flex align-items-center gap-3">
              {/* <SelectBox
                staticOption="Select Options"
                data={dropdownOptions}
                value={creditFilter}
                onChange={(selectedOption) => setCreditFilter(selectedOption)}
              /> */}
              <CreditHistorySelect
                staticOption="Select Options"
                options={dropdownOptions}
                value={creditFilter}
                onChange={(selectedOption) => {
                  setCreditFilter(selectedOption);
                }}
              />
              <DateRangePicker
                initialSettings={{
                  startDate: dateRange.startDate.toDate(),
                  endDate: dateRange.endDate.toDate(),
                  ranges: {
                    Today: [moment(), moment()],
                    Yesterday: [
                      moment().subtract(1, "days"),
                      moment().subtract(1, "days"),
                    ],
                    "Last 7 Days": [moment().subtract(6, "days"), moment()],
                    "Last 30 Days": [moment().subtract(29, "days"), moment()],
                    "This Month": [
                      moment().startOf("month"),
                      moment().endOf("month"),
                    ],
                    "Last Month": [
                      moment().subtract(1, "month").startOf("month"),
                      moment().subtract(1, "month").endOf("month"),
                    ],
                    "Last 3 Months": [
                      moment().subtract(3, "month").startOf("month"),
                      moment().subtract(1, "month").endOf("month"),
                    ],
                    "Last 6 Months": [
                      moment().subtract(6, "month").startOf("month"),
                      moment().subtract(1, "month").endOf("month"),
                    ],
                    "This Year": [
                      moment().startOf("year"),
                      moment().endOf("year"),
                    ],
                  },
                  locale: {
                    format: "YYYY-MM-DD",
                  },
                }}
                onApply={(e, _) => handleEvent(e, _)}
              >
                <button variant="primary" className=" date-picker">
                  {selectedRangeLabel}
                </button>
              </DateRangePicker>
            </div>
          </div>
          <div className="table-responsive credits-history-tbl-list p-4 pt-0">
            <Table className="common-table">
              <thead>
                <tr className="position-sticky top-0 z-2">
                  <th>
                    <div className="table-br">
                      <p>Date</p>
                    </div>
                  </th>
                  <th>
                    <div className="table-br">
                      <p>Description</p>
                    </div>
                  </th>
                  <th>
                    <div className="table-br">
                      <p>Customer</p>
                    </div>
                  </th>
                  <th>
                    <div className="table-br">
                      <p>Credit</p>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tableLoading ? (
                  <tr className="loader-tr-tbl">
                    <td colSpan="9">
                      <TableLoader />
                    </td>
                  </tr>
                ) : creditHistoryList?.data?.length === 0 ? (
                  <tr>
                    <td
                      className="text-center"
                      colSpan="7"
                      // colSpan={getColumnsForActiveTab(activeTab).length + 1}
                    >
                      <div className=" text-center w-100 blank-table-view">
                        <Image
                          src="/assets/images/component-common/blank-table.png"
                          alt="Blank-Table-Data-Image"
                          className="img-fluid"
                        />
                        <div className="mt-3">
                          <h5 className="fw-medium">Couldn't find any data.</h5>
                          <p className="pt-2 mt-1">
                            This report does not contain any points.
                            {/* Try to change your filter and try again. */}
                          </p>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : (
                  creditHistoryList?.data?.map((item, i) => {
                    return (
                      <tr key={i}>
                        <td>
                          <p>
                            {moment(item.created_at).format("MMMM D, YYYY")}
                          </p>
                          <span>
                            {moment(item.created_at).format("hh:mm A")}
                          </span>
                        </td>

                        <td>
                          <div className="d-flex flex-column gap-2">
                            {/* here add classname according message   class-list :  purple-cr,yellow-cr,green-cr ,red-cr  */}

                            <span
                              className={
                                item?.type === "recharge"
                                  ? "green-cr"
                                  : item?.type === "refund"
                                  ? "green-cr"
                                  : item?.type === "sent"
                                  ? "red-cr"
                                  : item?.type === "deduction"
                                  ? "purple-cr"
                                  : item?.type === "scheduled"
                                  ? "yellow-cr"
                                  : item?.type === "free_credits"
                                  ? "green-cr"
                                  : "red-cr"
                              }
                            >
                              {item?.type === "recharge"
                                ? "New Recharge"
                                : item?.type === "refund"
                                ? "Credit Refund"
                                : item?.type === "sent"
                                ? "Message Sent"
                                : item?.type === "deduction"
                                ? item?.description
                                : item?.type === "scheduled"
                                ? `Message Sent (Scheduled on ${moment(
                                    item?.campaign?.scheduler_date
                                  ).format("DD/MM/YYYY  h:mm a")})`
                                : item?.type === "free_credits"
                                ? "Free Credits"
                                : ""}
                            </span>
                            <p className="d-flex gap-2 align-items-center">
                                  {item?.campaign?.campaign_number && (
                                    <span>{item.campaign.campaign_number}</span>
                                  )}

                                  {item?.campaign?.name && (
                                    <>
                                      <span
                                        className="rounded-circle d-block"
                                        style={{
                                          width: "3px",
                                          height: "3px",
                                          backgroundColor: "#444050",
                                        }}
                                      ></span>
                                      <span>{item.campaign.name}</span>
                                    </>
                                  )}

                                  {/* {item?.description && (
                                    <>
                                      <span
                                        className="rounded-circle d-block"
                                        style={{
                                          width: "3px",
                                          height: "3px",
                                          backgroundColor: "#444050",
                                        }}
                                      ></span>
                                      <span>{item.description}</span>
                                    </>
                                  )} */}

                                  {item?.campaign?.status && (
                                    <>
                                      <span
                                        className="rounded-circle d-block"
                                        style={{
                                          width: "3px",
                                          height: "3px",
                                          backgroundColor: "#444050",
                                        }}
                                      ></span>
                                      <span className="text-capitalize">{item?.campaign?.status}</span>
                                    </>
                                  )}
                                </p>


                            {/* <div className="extra-items-cover">
                              {item?.credit_history?.failed && (
                                <>
                                  {" "}
                                  <span>
                                    Failed : {item?.credit_history?.failed} |{" "}
                                  </span>{" "}
                                </>
                              )}
                              {item?.credit_history?.invalid && (
                                <span>
                                  Invalid Number :{" "}
                                  {item?.credit_history?.invalid} |
                                </span>
                              )}
                              {item?.credit_history?.sent && (
                                <span>Sent : {item?.credit_history?.sent}</span>
                              )}
                            </div> */}
                            <div className="extra-items-cover">
                              {(() => {
                                let parsedHistory = {};
                                try {
                                  parsedHistory = item?.credit_history
                                    ? JSON.parse(item.credit_history)
                                    : {};
                                } catch (e) {
                                  console.error(
                                    "Invalid credit_history JSON",
                                    e
                                  );
                                }

                                return (
                                 <>
                                    {parsedHistory.failed && (
                                      <>
                                        <span>Failed : {parsedHistory.failed}</span>
                                        {(parsedHistory.invalid || parsedHistory.sent) && " | "}
                                      </>
                                    )}

                                    {parsedHistory.invalid && (
                                      <>
                                        <span>Invalid Number : {parsedHistory.invalid}</span>
                                        {parsedHistory.sent && " | "}
                                      </>
                                    )}

                                    {parsedHistory.sent && <span>Sent : {parsedHistory.sent}</span>}
                                    {/* {parsedHistory.test && <span>Test : {parsedHistory.test}</span>} */}
                                  </>
                                );
                              })()}
                            </div>
                          </div>
                        </td>

                        <td className="d-flex flex-row align-items-center gap-2">
                          {/* <span
                            className="d-flex align-items-center justify-content-center rounded-circle"
                            style={{
                              width: "34px",
                              height: "34px",
                              backgroundColor: "#EFEFEF",
                            }}
                          >
                            <UserIcon
                              width={16}
                              height={16}
                              color="#A5596A"
                              strokeWidth={1.5}
                            />
                          </span> */}
                          <div>
                            <p className="text-capitalize fw-medium">
                              {item?.campaign?.client_event?.name || "-"}
                            </p>
                            <span style={{ fontSize: "15px" }}>
                              {item.customer.mobile_number  || "-"}
                            </span>
                          </div>
                        </td>
                        <td>
                          {/* here add classname according value   class-list :  purple-cr,yellow-cr,green-cr ,red-cr  */}
                          <p
                            className={
                              item?.is_credited ? "green-cr" : "red-cr"
                            }
                          >
                            {item?.is_credited ? "+" : "-"}
                            {item.credits}
                          </p>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>

          <div className="common-table-foot-new d-flex flex-wrap align-items-center justify-content-between gap-4">
            {/* <p className="custom-table-infotext "> */}
            {/* Displaying {currentPage * limit?.value + 1} to{" "}
              {Math.min((currentPage + 1) * limit?.value, total)} of {total}{" "}
              Credits History */}
            {typeof total === "number" && !isNaN(total) && total > 0 && 
             creditHistoryList?.data?.length > 0 &&
            (
              <p className="custom-table-infotext">
                Displaying {currentPage * limit?.value + 1} to{" "}
                {Math.min((currentPage + 1) * limit?.value, total)} of {total}{" "}
                Credits History
              </p>
            )}

            {/* </p> */}
            {
              creditHistoryList?.data?.length > 0 && (
                <>
                <div className="d-flex gap-4">
                {/* {total > limit?.value && ( */}
                    <CreatableSelect
                      isClearable
                      options={recordsPerPageOptions}
                      value={limit}
                      onChange={handleChange}
                      placeholder="Select or create"
                      menuPortalTarget={document.body} // Render the menu at the body level
                      menuPlacement="top" // Display the options above the input
                      className="custom-pagination-visible-item"
                      styles={{
                        control: (base) => ({
                          ...base,
                          width: "170px", // Fixed width for the input field
                        }),
                        menu: (base) => ({
                          ...base,
                          width: "170px", // Fixed width for the dropdown menu
                        }),
                        menuPortal: (base) => ({
                          ...base,
                          zIndex: 9999, // Ensure it appears above everything
                        }),
                      }}
                    />
                    <CommonPagination
                      totalItems={total}
                      itemsPerPage={limit?.value}
                      currentPage={currentPage + 1}
                      onPageChange={handlePageChange}
                    />
                {/* )} */}
              </div>
                </>
              )
            }
            
          </div>
        </div>
      </Container>
      <Credit
        show={showModal}
        handleClose={handleClose}
        // limit={limit}
        // sortKey={sortKey}
        // sortOrder={sortOrder}
        // activeTab={activeTab}
      />
    </>
  );
};
export default List2;
